module.exports = __webpack_public_path__ + "assets/3.68da472d.png";